import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to the console
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{
          padding: '20px',
          fontFamily: 'Arial, sans-serif',
          maxWidth: '800px',
          margin: '50px auto',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <h1 style={{ color: '#e74c3c', marginBottom: '20px' }}>
            ⚠️ Une erreur s'est produite
          </h1>
          <p style={{ marginBottom: '20px', color: '#555' }}>
            L'application a rencontré une erreur inattendue. Veuillez rafraîchir la page ou contacter le support si le problème persiste.
          </p>
          
          {this.state.error && (
            <details style={{ marginTop: '20px' }}>
              <summary style={{ cursor: 'pointer', color: '#3498db', marginBottom: '10px' }}>
                Détails de l'erreur (cliquez pour développer)
              </summary>
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '15px',
                borderRadius: '4px',
                marginTop: '10px',
                overflow: 'auto',
                maxHeight: '400px'
              }}>
                <h3 style={{ color: '#e74c3c', marginBottom: '10px' }}>
                  Message d'erreur:
                </h3>
                <pre style={{
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  color: '#333',
                  marginBottom: '20px'
                }}>
                  {this.state.error.toString()}
                </pre>
                
                {this.state.errorInfo && (
                  <>
                    <h3 style={{ color: '#e74c3c', marginBottom: '10px' }}>
                      Stack trace:
                    </h3>
                    <pre style={{
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      color: '#666',
                      fontSize: '12px'
                    }}>
                      {this.state.errorInfo.componentStack}
                    </pre>
                  </>
                )}
              </div>
            </details>
          )}
          
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Rafraîchir la page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
